module.exports = __webpack_public_path__ + "media/images/browsers/firefox-1c5dfbef43d7ef95373b6bf7f93c58a6.svg";